import React from 'react';
import { Outlet } from 'react-router-dom';
import Footer from '../Footer';
import Header from '../Header';

export default function Layout() {
  return (
    <>
      <svg
        className="cs_knockout_svg"
        aria-hidden="true"
        focusable="false"
        width="0"
        height="0"
      >
        <filter id="cs-knockout-black" colorInterpolationFilters="sRGB">
          <feColorMatrix
            type="matrix"
            values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  2.4 2.4 2.4 0 -0.18"
          />
        </filter>
      </svg>
      <Header logoSrc="/images/logo.svg" variant="cs_heading_color" />
      <Outlet />
      <Footer />
    </>
  );
}
